import {Trade, mapTradeDbToType} from '@cp/model';
import {getDocs} from 'firebase/firestore';
import {getCurrentUserIdValidated} from '../../config/firebase';
import {getTradeCollection} from './getTradeCollection';

export async function listTrades(): Promise<Trade[]> {
  const uid = await getCurrentUserIdValidated();
  const colRef = getTradeCollection(uid);
  const snapshot = await getDocs(colRef);
  return snapshot.docs.map((docSnap) =>
    mapTradeDbToType({
      id: docSnap.id,
      data: docSnap.data.bind(docSnap),
    } as any),
  );
}
